import { Modal, ModalContent, ModalOverlay, Spinner } from '@chakra-ui/react';
import React from 'react';

const CustomSpinner = (props) => {
  const { isSpinnerOpen } = props;
  return (
    <Modal isOpen={isSpinnerOpen} isCentered>
      <ModalOverlay />
      <ModalContent bg='transparent' display='flex' justifyContent='center' alignItems='center' boxShadow='none'>
        <Spinner color='blue.500' size='xl' emptyColor='gray.200' />
      </ModalContent>
    </Modal>
  )
}

export default CustomSpinner